import { createAction, props } from '@ngrx/store';
import { ApiLegalDocuments } from '@app/core/legal-documents/api-legal-documents';

const TAG = '[Legal document]';

export const loadLegalDocuments = createAction(`${TAG} Load legal documents`);
export const loadLegalDocumentsSuccess = createAction(`${TAG} Load legal documents success`, props<{ legalDocuments: ApiLegalDocuments }>());
export const loadLegalDocumentsFailure = createAction(`${TAG} Load legal documents error`, props<{ error: string }>());

